export const MANUAL_SCRAPING_SETTINGS = {
  mode: 'Manual',
  proxy: 'DataCenter',
  fingerprints: 'Enabled',
  cookieBlocker: 'Enabled',
}

export const DEBUG_SCRAPING_SETTINGS = {
  ...MANUAL_SCRAPING_SETTINGS,
  debug: 'Enabled',
}
